import React from 'react';

export const GradientAndGlowDefs = ({
  id,
  sourceColor,
  targetColor,
}: {
  id: string;
  sourceColor: string;
  targetColor: string;
}) => {
  return (
    <defs>
      {/* <linearGradient id={`gradient-${id}`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#FF8763">
                <animate attributeName="offset" values="-0.5;1.0" dur="1s" repeatCount="indefinite" />
            </stop>
            <stop offset="0.1%" stopColor="#FF639D">
                <animate attributeName="offset" values="-0.4;1.1" dur="1s" repeatCount="indefinite" />
            </stop>
            <stop offset="0.2%" stopColor="white">
                <animate attributeName="offset" values="-0.3;1.2" dur="1s" repeatCount="indefinite" />
            </stop>
            <stop offset="0.3%" stopColor="#FF55B3">
                <animate attributeName="offset" values="-0.2;1.3" dur="1s" repeatCount="indefinite" />
            </stop>
            <stop offset="0.9%" stopColor="#FF7043">
                <animate attributeName="offset" values="0.4;1.4" dur="1s" repeatCount="indefinite" />
            </stop>
        </linearGradient> */}
      <linearGradient id={`gradient-${id}`} x1="0" y1="0" x2="1" y2="0">
        <stop offset="30%" stopColor={sourceColor} />
        <stop offset="70%" stopColor={targetColor} />
      </linearGradient>

      <linearGradient id={`animate-${id}`} x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="white" stopOpacity={0}>
          <animate attributeName="offset" values="-1.5;1.5" dur="2s" repeatCount="indefinite" />
        </stop>
        <stop offset="10%" stopColor="white" stopOpacity={0.6}>
          <animate attributeName="offset" values="-1;2.0" dur="2s" repeatCount="indefinite" />
        </stop>
        <stop offset="20%" stopColor="white" stopOpacity={0}>
          <animate attributeName="offset" values="-0.5;2.5" dur="2s" repeatCount="indefinite" />
        </stop>
      </linearGradient>

      <filter id="glow">
        <feGaussianBlur in="SourceGraphic" stdDeviation="8" result="blurred" />
        <feMerge>
          <feMergeNode in="blurred" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>

      {/* <filter id={`glow-${id}`} x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="3" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter> */}
    </defs>
  );
};
